"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const Modal_1 = __importDefault(require("../Modal"));
const Drawer_1 = __importDefault(require("../Drawer"));
/** Renders content in either a Modal or Drawer depending on screen size */
const ResponsiveDialog = (props) => {
    const r = (0, common_buoy_theme_1.useResponsive)();
    return (r({
        xs: (0, jsx_runtime_1.jsx)(Drawer_1.default, { ...props }),
        md: (0, jsx_runtime_1.jsx)(Modal_1.default, { ...props }),
    }) || null);
};
exports.default = ResponsiveDialog;
//# sourceMappingURL=index.js.map